



































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import u from '@/utility/utility';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import cartServices from '@/services/cart-services';
import DetailProduct from './DetailProduct.vue';
import commonService from '@/services/common-services';
@Component({
  components: {
    Loading,
    DetailProduct
  },
})
export default class MainPayService extends Vue {
  private isLoading = false;
  private searchTerm = '';
  private searchSite = 'TAOBAO';
  private searchResult: any = null;
  private showDetailProduct = false;
  private detailProductUrl = '';
  private detailProductKey = 0;
  private products: any[] = [];
  private currentPage = 1;
  private pageSize = 20;
  private hasMoreProducts = true;
  private isLoadingMore = false;
  private priceOrder: '' | 'asc' | 'desc' = '';
  private salesOrder: '' | 'asc' | 'desc' = '';
  private isSearchingByImage = false;
  private currentSearchImgUrl = '';
  private searchCategories = [
    {
      id: 1,
      name: 'Thời trang nữ',
      image: '/img/icons/thoi-trang-nu.png',
      keywords: ['Thời trang nữ', 'Quần áo cotton', 'Áo khoác nỉ', 'Chân váy', 'Váy liền', 'Áo sơ mi', 'Bộ đồ thời trang', 'Quần legging', 'Quần bò nữ', 'Quần áo nữ size lớn', 'Trang phục trung niên, người già', 'Váy cưới, lễ phục', 'Xu hướng phong cách']
    },
    {
      id: 2,
      name: 'Thời trang nam',
      image: '/img/icons/thoi-trang-nam.png',
      keywords: ['Thời trang nam', 'Áo phông T-shirt', 'Áo sơ mi', 'Áo khoác jacket', 'Quần âu', 'Quần bò nam', 'Áo dệt kim', 'Áo hoodie', 'Áo len', 'Áo vest nam', 'Bộ đồ thoải mái', 'Trang phục bóng chày', 'Áo gió']
    },
    {
      id: 3,
      name: 'Thời trang trẻ em',
      image: '/img/icons/thoi-trang-tre-em.png',
      keywords: ['Thời trang trẻ em', 'Áo khoác trẻ em', 'Trang phục trẻ em kiểu Hàn Quốc', 'Váy trẻ em', 'Đồ mẹ con']
    },
    {
      id: 4,
      name: 'Sản phẩm mẹ và bé',
      image: '/img/icons/sp-me-va-be.png',
      keywords: ['Sản phẩm mẹ và bé', 'Quần áo trẻ sơ sinh', 'Đồ bầu', 'Bỉm, tã, giấy ướt', 'Giặt xả tắm gội ăn uống', 'Máy tiện/ngoài trời']
    },
    {
      id: 5,
      name: 'Giày dép',
      image: '/img/icons/giay-dep.png',
      keywords: ['Giày dép', 'Giày nữ', 'Dép đi trong nhà', 'Giày vải', 'Giày nam', 'Giày trẻ em']
    },
    {
      id: 6,
      name: 'Đồ nội y',
      image: '/img/icons/do-noi-y.png',
      keywords: ['Đồ nội y', 'Thị trường đồ lót', 'Đồ lót tạo dáng, đồ lót gợi cảm', 'Thị trường áo lót', 'Thị trường đồ ngủ', 'Thị trường tất']
    },
    {
      id: 7,
      name: 'Trang phục thể thao',
      image: '/img/icons/trang-phuc-the-thao.png',
      keywords: ['Trang phục thể thao', 'Trang phục dã ngoại', 'Đồ bơi', 'Đồ bảo vệ balo']
    },
    {
      id: 8,
      name: 'Đồ chơi',
      image: '/img/icons/do-choi.png',
      keywords: ['Đồ chơi', 'Đồ chơi nam châm', 'Khối rubik giải tỏa stress', 'Gậy gỗ giải tỏa stress', 'Đồ chơi tiệc tùng', 'Đồ chơi giải trí', 'Đồ chơi trí tuệ', 'Đồ ăn uống, bánh kẹo giả', 'Đồ chơi trẻ em', 'Đồ chơi bông', 'Đồ chơi xếp hình ghép khối', 'Đồ chơi tự lắp ráp DIY', 'Nhạc cụ trẻ em', 'Sách vải trẻ em', 'Mô hình xe', 'Máy bay điều khiển', 'Đồ chơi mô hình', 'Nhà bóng', 'Tìm kiếm nhiều']
    },
    {
      id: 9,
      name: 'Túi xách, vali',
      image: '/img/icons/tui-xach-vali.png',
      keywords: ['Túi xách, vali', 'Ví mùa xuân hạ ' + new Date().getFullYear(), 'Mẫu túi, vali ' + new Date().getFullYear(), 'Túi ví nam', 'Túi, vali', 'Cặp sách khai giảng ' + new Date().getFullYear()]
    },
    {
      id: 10,
      name: 'Điện thoại',
      image: '/img/icons/dien-thoai.png',
      keywords: ['Điện thoại', 'Phụ kiện điện thoại di động', 'Điện thoại hàng chính hãng', 'Phụ kiện Apple']
    },
    {
      id: 11,
      name: 'Linh phụ kiện điện tử',
      image: '/img/icons/do-dien-tu.png',
      keywords: ['Linh phụ kiện điện tử', 'Sản phẩm Internet và ngoại vi', 'Bán dẫn', 'Công cụ phát triển', 'Thiết bị thụ động', 'Mô đun điện tử']
    },
    {
      id: 12,
      name: 'Phụ kiện thể thao',
      image: '/img/icons/phu-kien-the-thao.png',
      keywords: ['Phụ kiện thể thao', 'Đồ đi câu', 'Đồ cắm trại trên núi']
    },
    {
      id: 13,
      name: 'Điện gia dụng',
      image: '/img/icons/dien-gia-dung.png',
      keywords: ['Điện gia dụng', 'Chăm sóc sức khỏe', 'Đồ bếp, đồ gia dụng', 'Đồ điện gia dụng/Thiết bị âm thanh video', 'Thiết bị sinh hoạt']
    },
    {
      id: 14,
      name: 'Thiết bị điện tử',
      image: '/img/icons/thiet-bi-dien-tu.png',
      keywords: ['Thiết bị điện tử', 'Sản phẩm điện tử', 'Phụ kiện điện tử', 'Thiết bị thông minh', 'Thiết bị ngoại vi máy tính']
    },
    {
      id: 15,
      name: 'Trang điểm, mỹ phẩm',
      image: '/img/icons/trang-diem.png',
      keywords: ['Trang điểm, mỹ phẩm', 'Nước hoa trang điểm', 'Chăm sóc da', 'Dụng cụ trang điểm', 'Sản phẩm chăm sóc móng']
    },
    {
      id: 16,
      name: 'Chăm sóc sắc đẹp',
      image: '/img/icons/cs-sac-dep.png',
      keywords: ['Chăm sóc sắc đẹp', 'Chăm sóc cá nhân', 'Tẩy rửa gia đình', 'Khăn giấy, khăn ướt', 'Tẩy rửa quần áo']
    },
    {
      id: 17,
      name: 'Phụ kiện',
      image: '/img/icons/phu-kien.png',
      keywords: ['Phụ kiện', 'Khăn quàng, khăn lụa', 'Mũ, găn tay', 'Đồng hồ, kính mắt', 'Thắt lưng, dây lưng']
    },
    {
      id: 18,
      name: 'Dụng cụ đo',
      image: '/img/icons/dung-cu-do.png',
      keywords: ['Dụng cụ đo', 'Dụng cụ quang học', 'Dụng cụ đo nhiệt độ và độ ẩm', 'Dụng cụ đo lường']
    }
  ];

  get showMenu() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
  }

  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }

  get rate() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
  }

  private getSiteName(link) {
    if (!link) { return ''; }
    if (link.includes('1688')) { return '1688'; }
    if (link.includes('taobao')) { return 'Taobao'; }
    if (link.includes('tmall')) { return 'Tmall'; }
    return '';
  }

  private isMobile() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  }

  private isValidURL(str) {
    try {
      return str.includes('1688.com') || str.includes('taobao.com') || str.includes('tmall.com') || str.includes('e.tb.cn');
    } catch (_) {
      return false;
    }
  }

  private async created() {
    if (!this.rate) {
      await this.getRate();
    }
    // Thêm scroll listener
    window.addEventListener('scroll', this.handleScroll);
    // Lắng nghe Ctrl+V / Cmd+V toàn cục để tìm kiếm bằng ảnh
    document.addEventListener('paste', this.handleGlobalPaste);
    // if (this.products.length === 0 && !this.showDetailProduct) {
    //   await this.loadProducts();
    // }
  }

  private beforeDestroy() {
    // Xóa scroll listener khi component bị destroy
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('paste', this.handleGlobalPaste);
  }

  private handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // Kiểm tra nếu user đã scroll gần tới cuối trang (còn 200px)
    if (scrollTop + windowHeight >= documentHeight - 200) {
      this.loadMoreProducts();
    }
  }

  private async getRate() {
    const result = await commonService.exchangeRate();
    if (result && result.status === 200) {
      (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
      (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
    }
  }

  private getDetailProductUrl(itemUrl) {
    return `${this.extractItemId(itemUrl)}`;
  }

  private openDetailProductUrl(itemUrl) {
    this.searchTerm = itemUrl;
    this.searchProduct();
  }

  private extractItemId(url: string): string {
    if (!url) { return ''; }
    // Tìm url thực sự trong chuỗi nếu có dính text hoặc mã
    const urlMatch = url.match(/https?:\/\/[^\s]+/);
    if (urlMatch) {
      url = urlMatch[0];
    }
    try {
      const parsedUrl = new URL(url);
      const host = parsedUrl.hostname;
      if (host.includes('taobao.com') || host.includes('tmall.com')) {
        const id = parsedUrl.searchParams.get('id');
        const miId = parsedUrl.searchParams.get('miId') || parsedUrl.searchParams.get('mi_id');
        return id ? `https://${host}/item.htm?id=${id}${miId ? `&miId=${miId}` : ''}` : url;
      }
      return url;
    } catch (error) {
      return url;
    }
  }

  private async searchProduct() {
    // Kiểm tra xem searchTerm có phải là URL hay không
    if (this.isValidURL(this.searchTerm)) {
      // Nếu là URL, mở DetailProduct trong tab mới
      const detailUrl = this.getDetailProductUrl(this.searchTerm);
      const routeData = this.$router.resolve({
        name: 'detail-product-index',
        query: { itemUrl: detailUrl }
      });
      window.open(routeData.href, '_blank');
      return;
    }

    // Reset pagination khi tìm kiếm mới
    this.currentPage = 1;
    this.products = [];
    this.hasMoreProducts = true;
    this.currentSearchImgUrl = '';

    await this.loadSearchResults();
  }

  private async loadSearchResults() {
    // Tìm kiếm theo từ khóa bằng Xadal API
    if (this.currentPage === 1) {
      this.isLoading = true;
    } else {
      this.isLoadingMore = true;
    }

    try {
      const result = await cartServices.searchProductsByKeyword(
        this.searchTerm,
        this.searchSite.toLowerCase(),
        this.currentPage,
        this.pageSize,
        this.priceOrder,
        this.salesOrder
      );

      if (result && result.status === 200 && result.data) {
        // Xadal API response: { message: 'Success', data: { items: [...], paginate: {...} } }
        const responseData = result.data.data || result.data;
        const products: any[] = responseData.items || [];

        if (this.currentPage === 1) {
          this.products = products;
        } else {
          this.products.push(...products);
        }

        // Kiểm tra có còn dữ liệu để tải không
        this.hasMoreProducts = products.length >= this.pageSize;
      } else {
        // Báo lỗi nếu Xadal API không hoạt động
        const errorMsg = result && result.data && result.data.message ? result.data.message : 'Lỗi khi tìm kiếm sản phẩm';
        Vue.notify({
          group: 'foo',
          type: 'error',
          title: 'Lỗi!',
          text: errorMsg,
        });
      }
    } catch (error) {
      // Báo lỗi nếu Xadal API không hoạt động
      const err = error as any;
      const errorMsg = err && err.message ? err.message : 'Lỗi khi tìm kiếm sản phẩm';
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: 'Lỗi!',
        text: errorMsg,
      });
    }

    this.isLoading = false;
    this.isLoadingMore = false;
  }

  private async loadProducts() {
    this.isLoading = true;
    const result = await cartServices.listProducts();
    if (result && result.status === 200 && result.data.message === 'Success') {
      this.products.push(...result.data.data);
    }
    this.isLoading = false;
  }

  private searchByKeyword(keyword: string) {
    this.searchTerm = keyword;
    this.searchProduct();
  }

  private clearSearchResults() {
    this.products = [];
    this.searchTerm = '';
    this.currentPage = 1;
    this.hasMoreProducts = true;
    this.priceOrder = '';
    this.salesOrder = '';
    this.currentSearchImgUrl = '';
  }

  private async onSortChange(changedField: 'price' | 'sales') {
    if (changedField === 'price' && this.priceOrder) {
      this.salesOrder = '';
    }
    if (changedField === 'sales' && this.salesOrder) {
      this.priceOrder = '';
    }

    if (!this.searchTerm) {
      return;
    }

    this.currentPage = 1;
    this.products = [];
    this.hasMoreProducts = true;

    if (this.currentSearchImgUrl) {
      await this.loadImageSearchResults();
    } else {
      await this.loadSearchResults();
    }
  }

  private async loadImageSearchResults() {
    if (this.currentPage === 1) {
      this.isLoading = true;
    } else {
      this.isLoadingMore = true;
    }

    try {
      const platformMap = { 'TAOBAO': 'taobao', 'TMALL': 'taobao', '1688': '1688' };
      const platform = platformMap[this.searchSite] || 'taobao';

      const result = await cartServices.searchProductsByImageUrl(
        this.currentSearchImgUrl,
        platform,
        this.currentPage,
        30,
        this.priceOrder,
        this.salesOrder,
      );

      if (result && result.status === 200 && result.data) {
        const responseData = result.data.data || result.data;
        const products: any[] = responseData.items || [];

        if (this.currentPage === 1) {
          this.products = products;
        } else {
          this.products.push(...products);
        }
        this.hasMoreProducts = products.length >= 30;
      } else {
        const errorMsg = result && result.data && result.data.message ? result.data.message : 'Lỗi khi tải lại kết quả tìm kiếm bằng ảnh';
        Vue.notify({ group: 'foo', type: 'error', title: 'Lỗi!', text: errorMsg });
      }
    } catch (error) {
      const err = error as any;
      const errorMsg = err && err.message ? err.message : 'Lỗi khi tải lại kết quả tìm kiếm bằng ảnh';
      Vue.notify({ group: 'foo', type: 'error', title: 'Lỗi!', text: errorMsg });
    }

    this.isLoading = false;
    this.isLoadingMore = false;
  }

  private async loadMoreProducts() {
    if (!this.hasMoreProducts || this.isLoadingMore || !this.searchTerm) {
      return;
    }

    this.currentPage++;
    if (this.currentSearchImgUrl) {
      await this.loadImageSearchResults();
    } else {
      await this.loadSearchResults();
    }
  }

  private openProductDetail(product: any) {
    let productUrl = product.link || product.url || '';

    // Fallback: build URL from id + platform when link is missing
    if (!productUrl && product.id) {
      const platform = (product.platform || '').toLowerCase();
      if (platform === '1688' || platform === 'alibaba') {
        productUrl = `https://detail.1688.com/offer/${product.id}.html`;
      } else {
        // taobao / tmall
        productUrl = `https://item.taobao.com/item.htm?id=${product.id}&miId=${product.miId}`;
      }
    }
    else if(product.miId) {
      productUrl = `https://item.taobao.com/item.htm?&miId=${product.miId}`;
    }

    if (productUrl) {
      // Lưu context danh sách tìm kiếm để hiển thị "Sản phẩm tương tự" trong màn hình chi tiết
      if (this.products && this.products.length > 1) {
        try {
          const slimProducts = this.products
            .filter((p: any) => p.miId !== product.miId)
            .slice(0, 20)
            .map((p: any) => ({
              id: p.id,
              title: p.title,
              titleEn: p.titleEn,
              price: p.price,
              img_url: p.img_url,
              link: p.link || p.url,
              platform: p.platform,
              miId: p.miId,
            }));
          localStorage.setItem('similar_products_context', JSON.stringify({
            items: slimProducts,
            searchTerm: this.searchTerm,
            currentProductId: product.miId,
          }));
        } catch (e) { /* ignore */ }
      }

      const detailUrl = this.getDetailProductUrl(productUrl);
      const routeData = this.$router.resolve({
        name: 'detail-product-index',
        query: { itemUrl: detailUrl }
      });
      window.open(routeData.href, '_blank');
    }
  }

  private getPlatformName(platform: string): string {
    const platformMap = {
      'taobao': 'Taobao',
      'tmall': 'Tmall',
      '1688': '1688',
      'TAOBAO': 'Taobao',
      'TMALL': 'Tmall'
    };
    return platformMap[platform] || platform;
  }

  private formatPrice(price: any): string {
    if (!price) {
      return '';
    }

    // Nếu price là object có thuộc tính min/max
    if (typeof price === 'object' && price.min !== undefined) {
      if (price.min === price.max) {
        return `¥${price.min}`;
      } else {
        return `¥${price.min} - ¥${price.max}`;
      }
    }

    // Nếu price là string hoặc number
    return `¥${price}`;
  }

  private formatPriceVND(price: any): string {
    if (!price || !this.rate) {
      return '';
    }

    let numericPrice = 0;
    if (typeof price === 'object' && price.min !== undefined) {
      numericPrice = price.min;
    } else {
      numericPrice = parseFloat(price);
    }

    const vndPrice = numericPrice * this.rate;
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(vndPrice);
  }

  private getProductImage(product: any): string {
    // Kiểm tra img_url từ response mới trước
    if (product.img_url) {
      return u.proxyImage(product.img_url);
    }

    // Kiểm tra product.image (format cũ)
    if (product.image) {
      return u.proxyImage(product.image);
    }

    // Nếu không có image, kiểm tra images array
    if (product.images && Array.isArray(product.images) && product.images.length > 0) {
      return u.proxyImage(product.images[0]);
    }

    // Fallback image nếu không có hình ảnh nào
    return '/img/icons/no-image.png';
  }

  private triggerImageUpload() {
    (this.$refs.imageInput as HTMLInputElement).click();
  }

  private async handleImageUpload(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files;

    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];
    await this.processImageSearch(file);

    // Reset input
    target.value = '';
  }

  private async processImageSearch(file: File) {
    this.isSearchingByImage = true;

    try {
      const platformMap = { 'TAOBAO': 'taobao', 'TMALL': 'taobao', '1688': '1688' };
      const platform = platformMap[this.searchSite] || 'taobao';

      const result = await cartServices.searchProductsByImage(file, platform);

      if (result && result.status === 200 && result.data) {
        const responseData = result.data.data || result.data;
        const products: any[] = responseData.items || [];
        this.currentSearchImgUrl = responseData.img_url || '';

        if (products.length > 0) {
          this.products = products;
          this.currentPage = 1;
          this.hasMoreProducts = false;
          this.searchTerm = 'Tìm kiếm bằng hình ảnh';

          Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thành công!',
            text: `Tìm thấy ${products.length} sản phẩm tương tự`,
          });
        } else {
          Vue.notify({
            group: 'foo',
            type: 'info',
            title: 'Thông báo!',
            text: 'Không tìm thấy sản phẩm tương tự với hình ảnh này',
          });
        }
      } else {
        const errorMsg = result && result.data && result.data.message
          ? result.data.message
          : 'Lỗi khi tìm kiếm bằng hình ảnh';
        Vue.notify({
          group: 'foo',
          type: 'error',
          title: 'Lỗi!',
          text: errorMsg,
        });
      }
    } catch (error) {
      const err = error as any;
      const errorMsg = err && err.response && err.response.data && err.response.data.message
        ? err.response.data.message
        : 'Lỗi khi tìm kiếm bằng hình ảnh';
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: 'Lỗi!',
        text: errorMsg,
      });
    }

    this.isSearchingByImage = false;
  }

  private async handleGlobalPaste(event: ClipboardEvent) {
    const items = event.clipboardData && event.clipboardData.items;
    if (!items) { return; }
    for (const item of Array.from(items)) {
      if (item.type.indexOf('image') !== -1) {
        event.preventDefault();
        const file = item.getAsFile();
        if (file) { await this.processImageSearch(file); }
        break;
      }
    }
  }


  private handleSearchResults(ret: any, searchType: string) {
    // Xadal response: { data: { items: [...] } } hoặc { items: [...] }
    const items: any[] = (ret.data && ret.data.items) || ret.items || [];
    if (items.length > 0) {
      this.products = items;
      this.searchTerm = searchType;
      this.currentPage = 1;
      this.hasMoreProducts = items.length >= 20;

      Vue.notify({
        group: 'foo',
        type: 'success',
        title: 'Thành công!',
        text: `Tìm thấy ${items.length} sản phẩm tương tự`,
      });
    } else {
      Vue.notify({
        group: 'foo',
        type: 'info',
        title: 'Thông báo!',
        text: 'Không tìm thấy sản phẩm tương tự',
      });
    }
  }
}
